import { useMutation } from "@tanstack/react-query";
import { updateBrand } from "../api/updateBrand";
import { invalidateBrandQuery } from "../queries/useBrandQuery";
import { invalidateBrandsListQuery } from "../queries/usePagesListByBrandQuery";
import { BrandToUpdate } from "../types";

type Params = {
  brand: BrandToUpdate;
  brandId: string;
};

export const useUpdateBrandMutation = () => {
  return useMutation({
    mutationFn: async ({ brand, brandId }: Params) => {
      return await updateBrand(brandId, brand);
    },
    onSuccess: (_data, variables) => {
      invalidateBrandQuery(variables.brandId);
      invalidateBrandsListQuery();
    },
    onError: (e) => console.error(e),
  });
};
